import {
    BG_Draft_UPLOAD,BG_Draft_UPLOAD_ERROR,
    BG_Draft_UPDATE,BG_Draft_UPDATE_ERROR,
    BG_Draft_GET,BG_Draft_GET_ERROR,
    BG_DOC_DETAIL_GET,BG_DOC_DETAIL_GET_ERROR,
    PO_DETAIL_GET, PO_DETAIL_GET_ERROR,
    PO_BG_Draft_UPLOAD,PO_BG_Draft_UPLOAD_ERROR,
    PO_BG_Draft_UPDATE,PO_BG_Draft_UPDATE_ERROR,
    PO_BG_Draft_ACTION,PO_BG_Draft_ACTION_ERROR,
} from '../type'
import axios from 'axios';
import env from '../../ENV';

let ROOT_URL = env.BACKEND_URL;

export const saveBGDraftDocDetail = (data, userId) => async dispatch => {
    try {
        const res = await axios.post(`${ROOT_URL}saveBGDraftDocDetail`, {data: data, userId: userId});
        dispatch({
            type: BG_Draft_UPLOAD,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: BG_Draft_UPLOAD_ERROR,
            payload: console.log(e),
        })
    }
}

export const UpdateBgGraftDocDetail = (data, userId) => async dispatch => {
    try {
        const res = await axios.post(`${ROOT_URL}UpdateBgGraftDocDetail`, {data: data, userId: userId});
        dispatch({
            type: BG_Draft_UPDATE,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: BG_Draft_UPDATE_ERROR,
            payload: console.log(e),
        })
    }
}

export const GetBGDraftDocDetail = (data, userId) => async dispatch => {
    try {
        const res = await axios.get(`${ROOT_URL}GetBGDraftDocDetail`);
        dispatch({
            type: BG_Draft_GET,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: BG_Draft_GET_ERROR,
            payload: console.log(e),
        })
    }
}

export const GetPODetailDocDetail = ( userId) => async dispatch => {
    try {
        const res = await axios.post(`${ROOT_URL}GetPOasperSuplier`, {userId: userId});
        dispatch({
            type: PO_DETAIL_GET,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: PO_DETAIL_GET_ERROR,
            payload: console.log(e),
        })
    }
}

export const savePOBGDraftDocDetail = (data, userId, selectedPOSAPId, BGType, action, status, username) => async dispatch => {
    try {
        const res = await axios.post(`${ROOT_URL}savePOBGDraftDocDetail`, {data: data, BGType: BGType, selectedPOSAPId: selectedPOSAPId, userId: userId, status, username, action});
        console.log( res, "sdhfbskdbfksdbfs")
        dispatch({
            type: PO_BG_Draft_UPLOAD,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: PO_BG_Draft_UPLOAD_ERROR,
            payload: console.log(e),
        })
    }
}

export const GetBgDraftDocTableData = (userId, groupId) => async dispatch => {
    try {
        const res = await axios.post(`${ROOT_URL}GetBgDraftDocTableData`, {userId: userId, groupId: groupId});
        dispatch({
            type: BG_DOC_DETAIL_GET,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: BG_DOC_DETAIL_GET_ERROR,
            payload: console.log(e),
        })
    }
}

export const UpdatePOBGDraftDocDetail = ( userId, data, action, status, comment, username) => async dispatch => {
    try {
        const res = await axios.post(`${ROOT_URL}UpdatePOBGDraftDocDetail`, {data: data, userId: userId, status, action, comment, username: username});
        // console.log( selectedPOSAPId, "sdhfbskdbfksdbfs")
        dispatch({
            type: PO_BG_Draft_UPDATE,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: PO_BG_Draft_UPDATE_ERROR,
            payload: console.log(e),
        })
    }
}

export const getactionDetail = (item) => async dispatch => {
    try {
        const res = await axios.post(`${ROOT_URL}GetBgActionDetail`, {data: item});
        console.log(res, "sdhfbksjbsdkfjksdbfbdsf")
        dispatch({
            type: PO_BG_Draft_ACTION,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: PO_BG_Draft_ACTION_ERROR,
            payload: console.log(e),
        })
    }
}